import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const SeriesPlayPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SERIES_PLAY)}
      replace
      keepSearchParams
    />
  );
};
export default SeriesPlayPage;
